import { render, staticRenderFns } from "./confirmOrderTwo.vue?vue&type=template&id=468c1acd&"
import script from "./confirmOrderTwo.vue?vue&type=script&lang=js&"
export * from "./confirmOrderTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports